export const DEFAULT_TIMESTAMP_VALUE = "0:00"

export function formatTimestamp(seconds: number) {
  const totalSeconds = Math.max(0, Math.floor(seconds))
  const hours = Math.floor(totalSeconds / 3600)
  const minutes = Math.floor((totalSeconds % 3600) / 60)
  const restSeconds = totalSeconds % 60

  if (hours > 0) {
    return `${hours}:${String(minutes).padStart(2, "0")}:${String(restSeconds).padStart(2, "0")}`
  }

  return `${minutes}:${String(restSeconds).padStart(2, "0")}`
}

function isNumberPart(value: string) {
  const trimmed = value.trim()
  return /^\d+$/.test(trimmed)
}

export function getTimestampSeconds(timestamp: string): number | null {
  const parts = timestamp.trim().split(":")

  if (parts.length < 2 || parts.length > 3 || parts.some(part => !isNumberPart(part))) {
    return null
  }

  return parts
    .map(Number)
    .reverse()
    .reduce((seconds, value, index) => seconds + value * 60 ** index, 0)
}
